import {
  Button,
  CardActions,
  CardContent,
  CircularProgress,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from '@mui/material';
import { useFormik } from 'formik';
import { IStudentRegister } from '../interfaces';
import { StudentsValidationSchema } from '../validators/validatioSchemas';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { setStudentsModalState } from '../slice/studentSlice';
import useStudentsInitialState from '../hooks/useStudentsInitialState';
import { createStudent } from '../actions/studentsActions';

const StudentsForm = () => {
  const dispatch = useAppDispatch();
  const { loadingCreate } = useAppSelector(( state ) => state.student );
  const {
    getFieldProps, handleSubmit, errors, touched, resetForm,
  } = useFormik<IStudentRegister>({
    initialValues: useStudentsInitialState(),
    validationSchema: StudentsValidationSchema,
    enableReinitialize: true,
    onSubmit: async ( formValues ) => {
      await dispatch( createStudent( formValues ));
      dispatch( setStudentsModalState( false ));
      resetForm();
    },
  });
  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
    >
      <CardContent sx={{ borderBottom: '1px solid #E0E0E0' }}>
        <Grid container justifyContent="center" sx={{ maxWidth: '810px' }}>
          <Grid item xs={9} sm={11} sx={{ mb: 2.5 }}>
            <InputLabel
              htmlFor="name"
              error={touched.name && !!errors.name}
            >
              <Typography fontWeight="bold" fontSize={12}>Nombre</Typography>
            </InputLabel>
            <TextField
              size="small"
              id="name"
              fullWidth
              placeholder="Ingrese un Nombre"
              error={touched.name && !!errors.name}
              helperText={touched.name && errors.name}
              sx={{
                '& .MuiOutlinedInput-root > input': {
                  backgroundColor: '#F2F2F2',
                },
              }}
              {...getFieldProps( 'name' )}
            />
          </Grid>
          <Grid item xs={9} sm={11} sx={{ mb: 2.5 }}>
            <InputLabel
              htmlFor="lastname"
              error={touched.lastname && !!errors.lastname}
            >
              <Typography fontWeight="bold" fontSize={12}>Apellido</Typography>
            </InputLabel>
            <TextField
              size="small"
              id="lastname"
              fullWidth
              placeholder="Ingrese una Descripción"
              error={touched.lastname && !!errors.lastname}
              helperText={touched.lastname && errors.lastname}
              sx={{
                '& .MuiOutlinedInput-root > input': {
                  backgroundColor: '#F2F2F2',
                },
              }}
              {...getFieldProps( 'lastname' )}
            />
          </Grid>
          <Grid item xs={9} sm={11} sx={{ mb: 2.5 }}>
            <InputLabel
              htmlFor="email"
              error={touched.email && !!errors.email}
            >
              <Typography fontWeight="bold" fontSize={12}>Correo</Typography>
            </InputLabel>
            <TextField
              size="small"
              id="email"
              fullWidth
              placeholder="Ingrese una Descripción"
              error={touched.email && !!errors.email}
              helperText={touched.email && errors.email}
              sx={{
                '& .MuiOutlinedInput-root > input': {
                  backgroundColor: '#F2F2F2',
                },
              }}
              {...getFieldProps( 'email' )}
            />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ borderBottom: '1px solid #E0E0E0' }}>
        <Grid container justifyContent="center" sx={{ maxWidth: '810px' }}>
          <Grid item xs={9} sm={10} display="flex" justifyContent="center" gap={2} sx={{ mb: 1.5, mt: 1.5 }}>
            <Button
              color="inherit"
              size="small"
              sx={{
                mb: 1,
              }}
              disabled={loadingCreate}
              onClick={() => dispatch( setStudentsModalState( false ))}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              size="small"
              sx={{
                mb: 1,
              }}
              disabled={loadingCreate}
              endIcon={loadingCreate && ( <CircularProgress size={10} /> )}
            >
              Continuar
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </form>
  );
};

export default StudentsForm;
